module.exports = __webpack_public_path__ + "static/media/footer.4078a66a.svg";